export const callbackResolver = (callback: () => void | undefined): void => {
  if (typeof callback === 'function') return callback();
};
